import type {SearchDataService} from './search.data-service';
import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
import {getErrorMessage} from 'shared/utils/data-service-utils';
import type {LogService} from 'core/logging/log.service';

export class SearchService {

    public static serviceName = 'searchService'

    /*@ngInject*/
    constructor(private searchDataService: SearchDataService, private logService: LogService) {
    }

    public async search<T>(params: SearchParams): Promise<ViewableSearch<SearchParams, T>> {
        try {
            return this.searchDataService.search(params);
        } catch (err) {
            if (err.data.responseType === 'Exception' && err.data.simpleName === 'SearchExpiredException') {
                // @ts-ignore TODO: check if this condition is necessary
                delete params.id;
                return this.searchDataService.search(params);
            }
            this.logService.error(getErrorMessage(err));
            throw err;
        }
    }
}